import types from './types';

/**
 * In this reducer we capture the user interactions of the live map. If a certain
 * element is hovered over, the according data should be fetched.
 *
 * In the case of selection the url should change accordingly so that the panel
 * layout can change.
 *
 * Some considerations:
 * - if there a are going to be more types then devices and segments we might want to make a generic entity type.
 * - if all ids for devices and segments can be considered (or made) globally unique, we can simplify the reducer as well.
 */
export default function map(
  state = {
    currentHover: null,
    bounds: null,
    allFeatureBounds: null,
    center: null,
    viewMode: 'segments',
    isMapPanelOpen: false,
  },
  action
) {
  switch (action.type) {
    case types.ENTER_ENTITY:
      return {
        ...state,
        currentHover: {
          id: action.payload.id,
          type: action.payload.type,
        },
      };

    case types.LEAVE_ENTITY:
      /**
       * Only kill a hover if the leave event is about the current item. Not
       * sure if this is required, but would make it more robust possibly.
       */
      if (action.payload.id !== state.currentHover.id) return state;

      return {
        ...state,
        currentHover: null,
      };

    case types.UNSET_HOVER_STATE:
      return {
        ...state,
        currentHover: null,
      };

    case types.SET_BOUNDS:
      return {
        ...state,
        bounds: action.payload,
      };

    case types.SET_ALL_FEATURE_BOUNDS:
      return {
        ...state,
        allFeatureBounds: action.payload,
      };

    case types.SET_CENTER:
      return {
        ...state,
        center: action.payload,
      };

    case types.SET_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload,
      };

    case types.CLOSE_MAP_PANEL:
      return {
        ...state,
        isMapPanelOpen: false,
      };

    case types.OPEN_MAP_PANEL:
      return {
        ...state,
        isMapPanelOpen: true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/ducks/map/reducers.js